import React from "react";
import { useSelector } from "react-redux";
import Landing from "../Containers/Landing/";
import NoPermission from "../Containers/NoPermission";

function useItemValidator() {
  const user = useSelector((state) => state.AuthReducer?.user);
  const permissions = useSelector(
    (state) => state.AuthReducer?.user?.role?.access_permissions
  );
  const modifiedPerms = useSelector(
    (state) => state.AuthReducer?.user?.role?.permissions
  );
  const locations = useSelector((state) => state.AuthReducer?.user?.location);
  const subList = useSelector((state) => state.AuthReducer?.subList);

  const activeLocation = useSelector(
    (state) => state.SlickCareProfilesReducer.activeLocation
  );

  function filterByValue(array, string) {
    let data = null;

    if (array?.length > 0) {
      let tempResult = array.find((o) =>
        Object.keys(o).some((k) =>
          o[k]
            .toString()
            .toLowerCase()
            .includes(string.toString().toLowerCase())
        )
      );
      if (tempResult?.id) {
        data = tempResult?.item_name;
      }
    }
    return data;
  }

  function itemValidator(
    component, // component to render
    item_name, // item to check
    desired_permissions, // desired permission
    sub_bool, // should check for subscription
    checking_bool
  ) {
    let renderComponent = <></>;
    let canView = false;
    let permits = ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"];
    let sub_check_required = false;

    if (subList?.length > 0) {
      let found = subList.find((ele) => ele.item_name === item_name);
      if (found?.id) {
        sub_check_required = true;
      }
    }

    let permList =
      user?.is_master_admin === true ||
      user?.accounting_type === "administrator"
        ? permissions
        : user.permissions.map((ele) => {
            return {
              ...ele.item_details,
              permission: permits[ele.permission_id],
            };
          });

    // Check Permission
    let currentItem = permList?.find((x) => x.item_name === item_name);
    let currentPerm = currentItem?.permission ?? "NO ACCESS";
    let permission_item =
      permits.indexOf(currentPerm) >= permits.indexOf(desired_permissions) ??
      false;

    if (
      user?.is_master_admin === true ||
      user?.accounting_type === "administrator"
    ) {
      permission_item = true;
    }

    // Check Subscription on the basis of permission
    if (permission_item === true) {
      // if (sub_check_required === true) {
      let subscriptionList = [];
      let subscriptionData = null;
      let currentLocation;

      if (locations?.length > 0) {
        currentLocation = locations?.find(
          (ele) => ele.id == activeLocation?.id
        );

        if (currentLocation?.id) {
          subscriptionList =
            currentLocation?.subscription_package_details ?? [];
        }
      }

      // If user has permission , check for subscription
      if (subscriptionList?.item_name) {
        subscriptionData = subscriptionList?.item_name?.find(
          (ele) => ele.item_name === item_name
        );
      }

      if (subscriptionData) {
        renderComponent =
          subscriptionData?.subscription_status === false ? (
            <Landing item={item_name} />
          ) : (
            component
          );
        canView = subscriptionData?.id ? true : false;
      } else {
        renderComponent = <Landing item={item_name} />;
        canView = false;
      }
      // } else {
      //   // if subscription check is not required
      //   renderComponent = component;
      //   canView = true;
      // }
    } else {
      // if no permission
      renderComponent = <NoPermission />;
      canView = false;
    }

    return checking_bool ? canView : renderComponent;
  }

  return itemValidator;
}

export default useItemValidator;
